<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <span style="margin-right:10px;">{{$auth.user.nickname}}</span>
      <!--<img
        src="img/avatars/ico-profile.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />-->
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>{{$auth.user.nickname}}</strong></b-dropdown-header>
      <b-dropdown-item v-if="$auth.isPartner" @click="edit"><i class="fa fa-user" />Cadastro</b-dropdown-item>
      <b-dropdown-item @click="changePassword"><i class="fa fa-wrench" />Alterar senha</b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import eventbus from '../eventBus'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    logout() {
      // this.$store.dispatch('removeUser')
      // window.location = '/#/login'
      this.$auth.logout()
    },
    changePassword() {
      eventbus.$emit('ui-action:change-password', true)
    },
    edit(){
      this.$router.push('/account/edit')
    }
  }
}
</script>
